import React from "react";

const EXPERTISE_ITEMS = [
  {
    id: "contractor",
    label: "Speaks Contractor",
    text: "Instantly understands architectural shingles, tile, metal, TPO, storm damage, and insurance claims.",
  },
  {
    id: "scope",
    label: "Qualifies Scope & Budget",
    text: "Differentiates between full replacements ($15k+) and minor repair requests before booking the calendar.",
  },
  {
    id: "geography",
    label: "Knows Local Geography",
    text: "Checks availability for your estimators based on service areas and ZIP codes.",
  },
  {
    id: "training",
    label: "Zero Training Required",
    text: "Pre-configured with industry-proven response rules out of the box.",
  },
];

const ExpertiseSection = () => (
  <section className="cursor-section roofing-expertise" data-testid="roofing-expertise-section">
    <div className="cursor-container roofing-expertise-inner">
      <p className="roofing-expertise-badge">DEEP INDUSTRY EXPERTISE</p>
      <h2 className="roofing-expertise-title" data-testid="roofing-expertise-headline">
        What Your <span className="roofing-expertise-gain">Roofing Digital Employee</span> Knows
      </h2>
      <p className="roofing-expertise-subhead">
        Trained on Roofing, <span className="roofing-expertise-pain">Not General Customer Support</span>
      </p>
      <p className="roofing-expertise-lead">Your Digital Employee arrives fully trained on day one:</p>
      <div className="roofing-expertise-grid">
        {EXPERTISE_ITEMS.map((item) => (
          <article key={item.id} className="roofing-expertise-card" data-testid={`roofing-expertise-${item.id}`}>
            <h3 className="roofing-expertise-card-label">{item.label}</h3>
            <p className="roofing-expertise-card-text">{item.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ExpertiseSection;
